module.exports = __webpack_public_path__ + "static/img/E002.d245629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/E002.jpg
// module id = 11UC
// module chunks = 1